module.exports = __webpack_public_path__ + "static/img/showcase_lastingimpressions.d4b7573.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase_lastingimpressions.png
// module id = 756
// module chunks = 1